import { Component } from '@angular/core';

@Component({
  selector: 'app-assign-bed',
  templateUrl: './assign-bed.component.html',
  styleUrls: ['./assign-bed.component.css'],
  standalone: false,
})
export class AssignBedComponent {}
